'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresDestinationInfo = function () {
    function WinresDestinationInfo($scope, $window, ownerService, localizationService, $sce, productService, paramService, $q) {
        _classCallCheck(this, WinresDestinationInfo);

        this.$scope = $scope;
        this.$window = $window;
        this.ownerService = ownerService;
        this.localizationService = localizationService;
        this.$sce = $sce;
        this.productService = productService;
        this.paramService = paramService;
        this.$q = $q;
        this.state = 'waiting';
    }

    _createClass(WinresDestinationInfo, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().Destination
            // getOwnerData()

            this.data = this.winresReservationContext.getContext();

            if (this.useOwnerData === 'true') {
                this.winresReservationContext.getOwnerData().then(function (description) {
                    _this.description = description;
                });
            } else {
                // Loading destination from context.
                this.setState('loading');

                this.$scope.$watch('$ctrl.data.Destination', function () {
                    // Destination was changed.

                    _this.setState('loading');

                    var promises = [_this.getDestination(), _this.getProduct()];

                    _this.loadingPromise = _this.$q.all(promises).then(function (_ref) {
                        var _ref2 = _slicedToArray(_ref, 2),
                            destination = _ref2[0],
                            product = _ref2[1];

                        _this.getDestinationInfo(destination, product);
                    });
                });
            }

            this.$scope.showProductFeatures = this.showProductFeatures === 'true';
            this.$scope.showRating = this.showRating === 'true';
        }
    }, {
        key: 'getDestination',
        value: function getDestination() {
            var _this2 = this;

            return this.$q(function (resolve) {
                if (_this2.data.Destination != null) {
                    resolve(_this2.data.Destination);
                }
            });
        }
    }, {
        key: 'getProduct',
        value: function getProduct() {
            var _this3 = this;

            var urlParams = this.winresReservationContext.Params;

            return this.$q(function (resolve) {
                return _this3.paramService.getWinresParam('CanShowProductName').then(function (showProductName) {
                    if (showProductName.toUpperCase() === 'TRUE') {
                        _this3.productService.getReservableProduct(urlParams.DestinationCode, urlParams.ProductCode, _this3.localizationService.getLanguage(), 1).then(function (product) {
                            // Get first product in destination.
                            resolve(product);
                        });
                    } else {
                        resolve(null);
                    }
                });
            });
        }
    }, {
        key: 'getDestinationInfo',
        value: function getDestinationInfo(destination, product) {
            if (!destination) {
                return;
            }

            if (destination.DescriptionOfDestination) {
                this.description = destination.DescriptionOfDestination.split("[kuvat]");
                this.description[0] = this.$sce.trustAsHtml(this.description[0]);
                this.description[1] = this.$sce.trustAsHtml(this.description[1]);
                this.bold = [];
                this.str = destination.DescriptionOfDestination.split(/\n/);
                this.bold.push(this.str.shift());
                this.bold.push(this.str.join('\n'));

                if (destination.StreetAddress && destination.PostAddress) {
                    this.address = destination.StreetAddress + ', ' + destination.PostAddress + '<br><br>';
                }
            }

            this.images = destination.Images;
            switch (this.titleSource) {
                case 'name':
                    this.title = destination.DestinationExtraName ? destination.DestinationExtraName : destination.DestinationName;
                    break;
                case 'headline':
                default:
                    this.title = destination.Headline;
            }

            // Product name is optional.
            if (product != null) {
                // Add product name after destination name.
                this.title += product.DestinationInfo.ProductExtraName ? ', ' + product.DestinationInfo.ProductExtraName : ', ' + product.DestinationInfo.ProductName;
            }

            // Backwards compatibility for pohjolanmatkat.
            this.showDestinationInfo = true;

            this.setState('ready');

            // Google analytics.
            //this.analyticsService.destinationPageView(this.$scope, this.data);
        }
    }, {
        key: 'setState',
        value: function setState(state) {
            this.state = state;
        }
    }]);

    return WinresDestinationInfo;
}();

WinresDestinationInfo.$inject = ['$scope', '$window', 'ownerService', 'localizationService', '$sce', 'productService', 'paramService', '$q'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'winresDestinationInfo';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('winresDestinationInfo', require('./winresDestinationInfo.html'));
}]);

_module3.default.component('winresDestinationInfo', {
    templateUrl: getTemplate,
    controller: WinresDestinationInfo,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {
        useOwnerData: '@', // true / false (default). If true, gets the data to display with getOwnerData();
        showImages: '@', // Show image carousel. true / false
        showMap: '@', // Show reservation map. true / false
        titleSource: '@', // Either 'name', 'headline' (default)
        trustAsHtml: '@', // true / false (default)
        showProductFeatures: '@', // true / false (default).  If 'true' product features ("wifi: yes", etc) is shown.
        showRating: '@' // if true, star rating will be displayed before the description
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresDestinationInfo/winresDestinationInfo.js
// module id = 420
// module chunks = 2